import { render, staticRenderFns } from "./StudentCredentialsEdit.vue?vue&type=template&id=3c50eb9e&scoped=true&"
import script from "./StudentCredentialsEdit.vue?vue&type=script&lang=js&"
export * from "./StudentCredentialsEdit.vue?vue&type=script&lang=js&"
import style0 from "./StudentCredentialsEdit.vue?vue&type=style&index=0&id=3c50eb9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50eb9e",
  null
  
)

component.options.__file = "StudentCredentialsEdit.vue"
export default component.exports